import {ViewBase} from "@/rawdogjs/src/core/viewBase";
import {IView} from "@/rawdogjs/src/interfaces/IView";
import {CaptureEmailPresenter} from "./captureEmailPresenter";
import {Router} from "@/rawdogjs/src/router";
import {ParcelDependencyContainer} from "@/rawdogjs/src/core/ParcelDependencyContainer";

export class CaptureEmailView extends ViewBase implements IView {

    public _presenter: CaptureEmailPresenter;


    constructor(viewName: string, router: Router, dependencyContainer: ParcelDependencyContainer, presenter: CaptureEmailPresenter) {
        super(viewName, router, dependencyContainer);
        this._presenter = presenter;
    }

    set isSignUpButtonEnable(isEnabled: boolean) {
        if (isEnabled)
            (document.getElementById('btn-sign-up') as any).classList.remove("disabled");
        else
            (document.getElementById('btn-sign-up') as any).classList.add("disabled");

        (document.getElementById('btn-sign-up') as any).disabled = !isEnabled; //flip
    }



    get email() {
        return this.getValueById('email');
    }

    set email(email) {
        this.setValueById('email', email);
    }
    
    get firstName(){
        return this.getValueById('first-name');
    }
    
    set firstName(value){
        this.setValueById('first-name', value);
    }
    
    get lastName()
    {
        return this.getValueById('last-name');
    }
    
    set lastName(value){
        this.getValueById('last-name')
    }
    
    setPresenter(presenter: CaptureEmailPresenter) {
        this._presenter = presenter;
    }

    render(): void {
    }


}